import React from 'react';
import { CONTENT_LOCALES, hasContent } from '../utils/courseTranslations';

// Language tab bar for multilingual course forms. `translations` is the
// fr/ar form state — used to show a dot on tabs that have content.
const LocaleTabs = ({ active, onChange, translations }) => (
  <div className="locale-tabs" role="tablist">
    {CONTENT_LOCALES.map(({ code, label }) => (
      <button
        key={code}
        type="button"
        role="tab"
        aria-selected={active === code}
        className={`locale-tab ${active === code ? 'active' : ''}`}
        onClick={() => onChange(code)}
      >
        {label}
        {code !== 'en' && hasContent(translations?.[code]) && (
          <span className="locale-tab-dot" aria-hidden="true" />
        )}
      </button>
    ))}
  </div>
);

export default LocaleTabs;
